import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { combineLatest, Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-field-venue-id',
    templateUrl: './editor-booking-item-setting-field-venue-id.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingFieldVenueIdComponent implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  venueNames: { id: string, name: string }[];
  filteredVenueNames: Observable<{ id: string, name: string }[]>;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.venueNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(venueNames => this.venueNames = venueNames);

    this.filteredVenueNames = combineLatest(
      this.editorData.venueNames$,
      this.parentFormGroup.controls['id'].valueChanges.pipe(
        startWith(this.getVenueName(this.parentFormGroup.controls['id'].value))
      )
    ).pipe(
      takeUntil(this.destroyed$),
      map(([venues, value]) => this.filterVenueNames(venues, value))
    );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private filterVenueNames(venueNames: { id: string, name: string }[], value: string): { id: string, name: string }[] {
    if (venueNames === undefined) { return []; }
    if (value === null) { return venueNames; }

    const filterValue = value.toUpperCase();
    return venueNames.filter(venueName => venueName.name.toUpperCase().includes(filterValue));
  }

  getVenueName(id: string): string {
    if (this.venueNames === undefined) { return ''; }
    if (id === null) { return ''; }

    return this.venueNames.find(venueName => venueName.id === id)?.name ?? '';
  }
}
